// Auth0 tenant settings, baked in at BUILD time (CRA inlines process.env) : changing them requires
// a rebuild, not just a container restart.
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
};

/**
 * Local-dev switch: skips Auth0 entirely on the client. Only useful against an API started with
 * BYPASS_AUTH=true, which authenticates every request server-side. Build-time constant : code may
 * branch on it before hooks precisely because it can never change within a running app.
 */
export const bypassAuth = process.env.REACT_APP_BYPASS_AUTH === "true";

/** Config keys required for a real Auth0 login, used to render a setup hint instead of a broken redirect. */
export const getAuth0MissingFields = (): string[] => {
  const missing: string[] = [];
  if (!auth0Config.domain) missing.push("REACT_APP_AUTH0_DOMAIN");
  if (!auth0Config.clientId) missing.push("REACT_APP_AUTH0_CLIENT_ID");
  return missing;
};
